import UILink from 'UIComponents/link/UILink';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const ExitSearchAndFilterModeButton = ({
  exitHandler = () => {}
}) => {
  return /*#__PURE__*/_jsx(UIBackButton, {
    className: "p-y-4",
    children: /*#__PURE__*/_jsx(UILink, {
      onClick: exitHandler,
      "data-test-id": "exit-search-and-filtering-mode-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.exit"
      })
    })
  });
};
ExitSearchAndFilterModeButton.displayName = 'ExitSearchAndFilterModeButton';
export default ExitSearchAndFilterModeButton;